import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as helpers from '../../../utils/helpers'
import * as Brands from '@fortawesome/free-brands-svg-icons'
import {
    Box, Container, Stack, Tooltip, Typography,
    List, ListItem, ListItemText,
    IconButton,
    Button,
} from '@mui/material'

const StreamLinks = (props) => {
    const { albums, albumNav, album, artistLinks, view } = props
    const linkIconCheck = (l) => {
        // console.log('[linkIconCheck] brands?.some((k)=>l?.includes(k.toString))',brands?.find((k)=>l?.includes(k?.toString())))
        let result = helpers.brands?.find((k) => l?.includes(k?.toString()))
        if (result) {
            // console.log("link result:", result)
            // console.log("link result formatted:", result?.charAt(0).toUpperCase() + result?.slice(1))
            return result?.charAt(0).toUpperCase() + result?.slice(1);
        } else if (l?.includes('youtu.be')) {
            return 'Youtube'
        } else { return false }
    }
    let streams
    if (artistLinks) {
        streams = artistLinks
    } else {
        streams = helpers.hasValue(album) ? album?.streaming : albums[albumNav]?.streaming
    }
    return (
        <>
            {helpers.hasValue(streams) && (<Box sx={{
                position: 'relative',//bottom:'0px',
                display: 'flex',
                //border:'1px solid red', 
                minHeight: '1.5rem',
                alignContent: 'center',
                gap: '0.5rem',
                padding: '0.125rem',
                // justifyContent:'center',
                width: '100%', margin: 'auto'
            }}>

                {!artistLinks ? Object.keys(streams).map((l, j) => {
                    let album_title = helpers.hasValue(album) ? album?.title : albums[albumNav]?.title
                    let link = helpers.hasValue(album) ? album?.streaming[`${l}`] : albums[albumNav]?.streaming[`${l}`]
                    // console.log('album_name:', album_title)
                    if (linkIconCheck(link)) {
                        let iconName = linkIconCheck(link)
                        // console.log('iconName:', iconName)
                        return (
                            <Tooltip title={`${iconName} ${album_title == 'Baseline' ? '( "key of Me" )' : ''}`} key={j}>

                                <div
                                    className='button-woddle'
                                    style={{
                                        // display:'flex',
                                        color: '#000',
                                        width: '1.5rem', height: '1.5rem',
                                        '&:hover': { background: 'rgba(144, 254, 195,0.5)' },
                                        // border:'1px solid blue', 
                                        borderRadius: '3px',
                                        alignContent: 'center',
                                        minWidth: '1rem', minHeight: '1rem'
                                    }} //key={i}

                                    key={j}
                                >
                                    <a
                                        style={{
                                            // display:'flex',
                                            color: '#000',

                                            // border:'1px solid blue', 
                                            borderRadius: '3px',
                                            alignContent: 'center',
                                            minWidth: '1rem', minHeight: '1rem'
                                        }} //key={i}
                                        href={link}
                                        target='_blank'
                                        key={j}
                                    >
                                        {iconName !== 'Pandora' && <FontAwesomeIcon icon={Brands['fa' + iconName]} key={j} />}
                                        {iconName === 'Pandora' && <img style={{ height: '1.2rem' }}
                                            src={view === 'home' ? '/assets/pandora-icon.svg' : '/assets/pandora-icon-grn.svg'} key={j} alt='pandora' />}

                                    </a>
                                </div>
                            </Tooltip>
                        )
                    }


                }) :
                    Object.keys(streams).map((l, j) => {
                        // let album_title = helpers.hasValue(album) ? album?.title : albums[albumNav]?.title
                        let link = artistLinks[`${l}`]
                        // console.log('album_name:', album_title)
                        if (linkIconCheck(link)) {
                            let iconName = linkIconCheck(link)
                            // console.log('iconName:', iconName)
                            return (
                                <Tooltip title={`${iconName}`} key={j}>

                                    <div
                                        className='button-woddle'
                                        style={{
                                            // display:'flex',
                                            color: '#00FF00',
                                            width: '1.5rem', height: '1.5rem',
                                            '&:hover': { background: 'rgba(144, 254, 195,0.5)' },
                                            // border:'1px solid blue', 
                                            cursor: 'pointer',
                                            borderRadius: '3px',
                                            alignContent: 'center',
                                            minWidth: '1rem', minHeight: '1rem'
                                        }} //key={i}

                                        key={j}
                                    >
                                        <a
                                            style={{
                                                // display:'flex',
                                                color: '#00FF00',
                                                cursor: 'pointer',
                                                // border:'1px solid blue', 
                                                borderRadius: '3px',
                                                alignContent: 'center',
                                                minWidth: '1rem', minHeight: '1rem'
                                            }} //key={i}
                                            href={link}
                                            target='_blank'
                                            key={j}
                                        >
                                            {iconName === 'Pandora' && <img style={{
                                                borderRadius: '3px',
                                                height: '1rem',//backgroundColor: '#00FF00', 
                                                cursor: 'pointer'
                                            }}
                                                src={view === 'home' ? '/assets/pandora-icon.svg' : '/assets/pandora-icon-grn.svg'} key={j} alt='pandora' />}

                                            {iconName !== 'Pandora' && <FontAwesomeIcon icon={Brands['fa' + iconName]} key={j} />}

                                        </a>
                                    </div>
                                </Tooltip>
                            )
                        }


                    })
                }
            </Box>)
            }
        </>
    )
}

export default StreamLinks